import ParameterErrors from '../errors/ParameterErrors';
import ClickedOffManager from '../ui_core/ClickedOffManager';
import SubMenuHeaderNonReact from '../components/SubMenuHeaderNonReact';
import BrochuresManager from './BrochuresManager';
import BrochuresMenuEntry from './BrochuresMenuEntry';
import MenuType from '../enums/MenuType';
import './BrochuresMenu.css';
const {throwNotProvided}=ParameterErrors;
export default class BrochuresMenu{	
	constructor(params){
		const{menuManager, getHandlesActivateButton}=params;
		this._iMenuManager  = menuManager;
		this._getHandlesActivateButton = getHandlesActivateButton;
		this.show = this.show.bind(this);
		this.hide = this.hide.bind(this);
		this._updateNoBrochuresVisibility = this._updateNoBrochuresVisibility .bind(this);
		this._setNoBrochuresVisible = this._setNoBrochuresVisible.bind(this);
		this._brochuresBeingGeneratedChanged = this._brochuresBeingGeneratedChanged.bind(this);
		this._releaseHandleActivateIcon = this._releaseHandleActivateIcon.bind(this);
		this._removeEntry = this._removeEntry.bind(this);
		this._addEntryForNewBrochureBeingGenerated = this._addEntryForNewBrochureBeingGenerated.bind(this);
		this._releaseHandleActivateIcon = this._releaseHandleActivateIcon.bind(this);
		this._element = document.createElement('div');
		this._element.classList.add('brochures-menu');
		this._element.classList.add('menu');
		this._subMenuHeader = new SubMenuHeaderNonReact({ title:"Brochures", menuManager:menuManager});
		this._element.appendChild(this._subMenuHeader.element);
		this._entriesWrapperElement = document.createElement('div');
		this._entriesWrapperElement.classList.add('entries-wrapper');
		this._entriesElement = document.createElement('div');
		this._entriesElement.classList.add('entries');
		this._element.appendChild(this._entriesWrapperElement);
		this._entriesWrapperElement.appendChild(this._entriesElement);
		this._clickedOffManager = new ClickedOffManager({element:this._element, hide:this.hide});
		this._mapBrochureGenerationIdentifierToEntry = new Map();
		this._noBrochuresElement = document.createElement('div');
		this._noBrochuresElement.classList.add('no-brochures');
		this._noBrochuresElement.innerHTML = 'Downloaded brochures will appear here';
		this._element.appendChild(this._noBrochuresElement);
		this._noBrochuresElement.classList.add('visible');
		BrochuresManager.instance.addEventListener('brochuresBeingGeneratedChanged', this._brochuresBeingGeneratedChanged);
	}
	get element(){
		return this._element;
	}
	get menuType(){
		return MenuType.BROCHURES;
	}
	show(params){
		const scrollToBottom = params?.scrollToBottom;
		this._element.classList.add('visible');
		this._iMenuManager.showMe(this);
		this._clickedOffManager.register();
		this._releaseHandleActivateIcon();
		this._handlActivateButton = this._getHandlesActivateButton(MenuType.BROCHURES).take();
		if(scrollToBottom){
			this._entriesWrapperElement.scrollTop = this._entriesWrapperElement.scrollHeight;
		}
	}
	_releaseHandleActivateIcon(){
		if(!this._handlActivateButton)return;
		this._handlActivateButton.dispose();
		this._handlActivateButton= null;
	}
	hide(){
		this._releaseHandleActivateIcon()
		this._element.classList.remove('visible');
		this._clickedOffManager.dispose();
		this._iMenuManager.close();
	}
	_brochuresBeingGeneratedChanged(e){
		const currentBrochureGenerationIdentifiersNotSeen = Array.from(this._mapBrochureGenerationIdentifierToEntry.keys());
		const brochuresBeingGenerated = e.brochuresBeingGenerated;
		brochuresBeingGenerated.forEach(brochureBeingGenerated=>{
			const index = currentBrochureGenerationIdentifiersNotSeen.indexOf(brochureBeingGenerated.brochureGenerationIdentifier);
			if(index >=0)currentBrochureGenerationIdentifiersNotSeen.splice(index, 1);
			else this._addEntryForNewBrochureBeingGenerated(brochureBeingGenerated);
		});
		currentBrochureGenerationIdentifiersNotSeen.forEach(brochureGenerationIdentifierNotSeen=>{
			const entry = this._mapBrochureGenerationIdentifierToEntry.get(brochureGenerationIdentifierNotSeen);
			if(!entry)return;
			this._removeEntry(entry);
		});
	}
	_removeEntry(entry){
		entry.dispose();
		this._mapBrochureGenerationIdentifierToEntry.delete(entry.brochureGenerationIdentifier);
		this._entriesElement.removeChild(entry.element);
		this._updateNoBrochuresVisibility();
	}
	_addEntryForNewBrochureBeingGenerated(brochureBeingGenerated){
		const brochuresMenuEntry = new BrochuresMenuEntry({brochureBeingGenerated:brochureBeingGenerated});
		this._mapBrochureGenerationIdentifierToEntry.set(brochuresMenuEntry.brochureGenerationIdentifier, brochuresMenuEntry);
		this._entriesElement.appendChild(brochuresMenuEntry.element);
		this._updateNoBrochuresVisibility();
	}
	_updateNoBrochuresVisibility(){
		this._setNoBrochuresVisible(this._mapBrochureGenerationIdentifierToEntry.size<=0);
	}
	_setNoBrochuresVisible(value){
		if(value)this._noBrochuresElement.classList.add('visible');
		else this._noBrochuresElement.classList.remove('visible');
	}
}